/* Book set page: tick or untick books, replace a book with another of the same subject from that year,
   and add the chosen books to the cart as ordinary books. */
(function(){
  var root=document.querySelector('[data-mb-set]');if(!root)return;
  var NAME=root.getAttribute('data-name'),YEAR=root.getAttribute('data-year');
  var card=document.querySelector('[data-setcard]'),rep=document.querySelector('[data-rep]');
  function rows(){return Array.prototype.slice.call(root.querySelectorAll('[data-sb]'))}
  function money(c){return '₹'+(c/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}
  function ord(e){e=String(e==null?'':e).trim();if(!/^\d+$/.test(e))return e;var n=+e,m=n%100;return e+((m>10&&m<14)?'th':({1:'st',2:'nd',3:'rd'})[n%10]||'th')}
  function esc(t){return (t==null?'':String(t)).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function q(r,s){return r.querySelector(s)}

  // ---------- the floating card ----------
  function paint(){
    var all=rows(),on=all.filter(function(r){return q(r,'[data-sb-on]').checked}),
        buy=on.filter(function(r){return r.getAttribute('data-av')==='1'}),
        tot=0,mrp=0;
    buy.forEach(function(r){tot+=+r.getAttribute('data-price');mrp+=+r.getAttribute('data-mrp')});
    q(card,'[data-sc-count]').textContent=on.length+' of '+all.length+' books';
    q(card,'[data-sc-total]').textContent=money(tot);
    q(card,'[data-sc-mrp]').textContent=mrp>tot?money(mrp):'';
    var b=q(card,'[data-sc-add]');b.disabled=!buy.length;
    b.textContent=!buy.length?'Tick a book to start':'Add '+buy.length+(buy.length===1?' book':' books')+' to cart';
    all.forEach(function(r){r.classList.toggle('is-off',!q(r,'[data-sb-on]').checked)});
  }
  root.addEventListener('change',function(e){if(e.target.closest('[data-sb-on]'))paint()});

  // ---------- replace ----------
  var items=null,loading=null,cur=null,freq={};
  function load(){
    if(items)return Promise.resolve(items);
    if(loading)return loading;
    if(!window.mbLoad||!YEAR)return Promise.resolve([]);
    loading=window.mbLoad(YEAR).then(function(list){
      items=list;freq={};list.forEach(function(i,ix){i._ix=ix;i.subj.forEach(function(s){freq[s]=(freq[s]||0)+1})});
      rows().forEach(function(r){var s=mainSubj(r);if(s)q(r,'[data-sb-subj]').textContent=s});
      return items;
    });
    return loading;
  }
  // the most specific subject a book carries in this year (Histology rather than Anatomy)
  function mainSubj(r){
    var ss=(r.getAttribute('data-subj')||'').split('|').filter(function(s){return s&&s!=='Others'&&s!=='Pocket Reference'});
    if(!ss.length)return '';
    ss.sort(function(a,b){return (freq[a]||1e9)-(freq[b]||1e9)});return ss[0];
  }
  var REG=[['upper limb','thorax'],['lower limb','abdomen','pelvis'],['head','neck','brain','neuro'],['general anatomy']];
  function regs(t){t=String(t||'').toLowerCase();return REG.map(function(g){return g.some(function(w){return t.indexOf(w)>-1})?1:0})}
  function inSet(vid){return rows().some(function(r){return r.getAttribute('data-vid')==String(vid)})}
  function draw(){
    var subj=mainSubj(cur),term=(q(rep,'[data-rep-q]').value||'').toLowerCase().trim(),list=q(rep,'[data-rep-list]');
    var pool=items.filter(function(i){return i.subj.indexOf(subj)>-1&&String(i.vid)!==cur.getAttribute('data-vid')&&!inSet(i.vid)});
    if(term)pool=pool.filter(function(i){return (i.t+' '+i.a+' '+i.v).toLowerCase().indexOf(term)>-1});
    // same body region first (Vol 3 Head and Neck finds the other Head and Neck volumes), then the shop's fast-seller order
    var cr=regs(q(cur,'[data-sb-t]').textContent);
    function rm(i){var r=regs(i.t),s=0;for(var k=0;k<r.length;k++)if(cr[k]&&r[k])s++;return s}
    pool.sort(function(a,b){return (b.av-a.av)||(rm(b)-rm(a))||((a._ix||0)-(b._ix||0))});
    if(!pool.length){list.innerHTML='<p class="mb-rep__none">No other '+esc(subj)+' books'+(term?' match “'+esc(term)+'”':'')+'.</p>';return}
    list.innerHTML=pool.map(function(i,ix){
      return '<div class="mb-rep__row">'+(i.img?'<img src="'+esc(i.img)+'" alt="" loading="lazy">':'<span class="ph"></span>')+
        '<div class="tx"><b>'+esc(i.t)+'</b><small>'+esc([i.a,i.ed?ord(i.ed)+' edition':'',i.v].filter(Boolean).join(' · '))+'</small></div>'+
        '<span class="pr">'+money(i.p)+'</span>'+
        (i.av?'<button type="button" class="mb-btn mb-btn--line" data-rep-pick="'+ix+'">Choose</button>':'<button type="button" class="mb-btn mb-btn--line" disabled>Sold out</button>')+'</div>';
    }).join('');
    list._pool=pool;
  }
  function open(r){
    cur=r;rep.hidden=false;document.documentElement.style.overflow='hidden';
    q(rep,'[data-rep-q]').value='';q(rep,'[data-rep-cur]').textContent='Instead of: '+q(r,'[data-sb-t]').textContent;
    q(rep,'[data-rep-list]').innerHTML='<p class="mb-rep__none">Loading books…</p>';
    load().then(function(){
      var s=mainSubj(r);q(rep,'[data-rep-subj]').textContent=s?s+' books for this year':'Replace';
      q(rep,'[data-rep-q]').placeholder='Search '+(s||'these')+' books by title or author';draw();q(rep,'[data-rep-q]').focus();
    }).catch(function(){q(rep,'[data-rep-list]').innerHTML='<p class="mb-rep__none">Couldn’t load the books. Please try again.</p>'});
  }
  function close(){rep.hidden=true;document.documentElement.style.overflow='';if(cur){var b=q(cur,'[data-sb-rep]');if(b)b.focus()}cur=null}
  function swap(r,i){
    if(!r._orig)r._orig={vid:r.getAttribute('data-vid'),h:r.getAttribute('data-h'),subj:r.getAttribute('data-subj'),price:r.getAttribute('data-price'),mrp:r.getAttribute('data-mrp'),av:r.getAttribute('data-av'),
      img:q(r,'.mb-sb__img').innerHTML,t:q(r,'[data-sb-t]').textContent,a:q(r,'[data-sb-a]').textContent,p:q(r,'[data-sb-p]').textContent,m:q(r,'[data-sb-m]').textContent};
    var mrp=Math.max(i.c||0,i.p);
    set(r,{vid:i.vid,h:i.h,subj:r.getAttribute('data-subj'),price:i.p,mrp:mrp,av:i.av?'1':'0',
      img:i.img?'<img src="'+esc(i.img)+'" alt="" loading="lazy">':'<span class="mb-card__noimg">'+esc(i.t.slice(0,40))+'</span>',
      t:i.t,a:[i.a,i.ed?ord(i.ed)+' edition':''].filter(Boolean).join(' · '),p:money(i.p),m:mrp>i.p?money(mrp):''});
    var was=q(r,'[data-sb-was]');was.hidden=false;
    was.innerHTML='Replaced <b>'+esc(r._orig.t)+'</b> · <button type="button" data-sb-undo>Undo</button>';
    r.classList.add('is-swapped');q(r,'[data-sb-on]').checked=true;
  }
  function set(r,d){
    r.setAttribute('data-vid',d.vid);r.setAttribute('data-h',d.h);r.setAttribute('data-price',d.price);r.setAttribute('data-mrp',d.mrp);r.setAttribute('data-av',d.av);
    q(r,'.mb-sb__img').innerHTML=d.img;q(r,'[data-sb-t]').textContent=d.t;q(r,'[data-sb-a]').textContent=d.a;q(r,'[data-sb-p]').textContent=d.p;q(r,'[data-sb-m]').textContent=d.m;
    r.querySelectorAll('[data-sb-link]').forEach(function(a){a.href='/products/'+d.h});
    var out=q(r,'[data-sb-out]');if(out)out.hidden=d.av==='1';
  }
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-sb-rep]');if(b){open(b.closest('[data-sb]'));return}
    var u=e.target.closest('[data-sb-undo]');if(u){var r=u.closest('[data-sb]');if(r._orig){set(r,r._orig);r._orig=null}q(r,'[data-sb-was]').hidden=true;r.classList.remove('is-swapped');paint()}
  });
  rep.addEventListener('click',function(e){
    if(e.target===rep||e.target.closest('[data-rep-close]')){close();return}
    var p=e.target.closest('[data-rep-pick]');if(p&&cur){var i=q(rep,'[data-rep-list]')._pool[+p.getAttribute('data-rep-pick')];var r=cur;swap(r,i);close();paint();
      r.classList.add('is-flash');setTimeout(function(){r.classList.remove('is-flash')},900)}
  });
  rep.addEventListener('input',function(e){if(e.target.closest('[data-rep-q]')&&cur&&items)draw()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!rep.hidden)close()});

  // ---------- add to cart ----------
  q(card,'[data-sc-add]').addEventListener('click',function(){
    var b=this,buy=rows().filter(function(r){return q(r,'[data-sb-on]').checked&&r.getAttribute('data-av')==='1'});if(!buy.length)return;
    b.disabled=true;var label=b.textContent;b.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:buy.map(function(r){return {id:+r.getAttribute('data-vid'),quantity:1}})})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(){location.href='/cart'})
      .catch(function(err){b.disabled=false;b.textContent=label;var t=document.querySelector('.mb-toast');if(t){t.textContent=(err&&err.description)||'Could not add the set. Please try again.';t.classList.add('is-on');setTimeout(function(){t.classList.remove('is-on')},3000)}});
  });

  // mb-find.js (which provides mbLoad) runs after this script, so wait for DOMContentLoaded before loading the shelf list
  paint();
  if(window.mbLoad)load();else document.addEventListener('DOMContentLoaded',function(){load()});
})();
